import { STRING_TO_TERMS, TERMS } from '../constants/termsAndDuration.js';

const toTerm = (unit) => {
    return Object.values(TERMS).includes(unit) ? unit : STRING_TO_TERMS[unit];
};

export { toTerm };
//# sourceMappingURL=toTerm.js.map
